/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var brightsmith_core_1 = require("brightsmith-core");

var constants_1 = require("../constants");

var initialState = {
  configuration: {},
  configCode: '',
  data: {},
  didInvalidate: false,
  isLoading: false,
  hasLoaded: false,
  overrides: [],
  price: 0,
  session: null,
  stash: null
};

var apiReducer = function apiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var assign = function assign(update) {
    return Object.assign({}, state, update);
  };

  console.log('api.reducer', action);

  switch (action.type) {
    case constants_1.API.ERROR:
      {
        var isLoading = action.isLoading,
            error = action.error;
        return Object.assign({}, state, {
          error: error,
          isLoading: isLoading
        });
      }

    case constants_1.API.RECEIVE:
      {
        var response = action.response,
            hasLoaded = action.hasLoaded,
            _isLoading = action.isLoading;
        var data = brightsmith_core_1.ApiNormalizer.run(response);
        console.log('api.receive', data);
        return Object.assign({}, state, {
          hasLoaded: hasLoaded,
          isLoading: _isLoading,
          configCode: data.currentConfigCode || state.configCode,
          data: data
        });
      }

    case constants_1.API.REQUEST:
      {
        var _isLoading2 = action.isLoading;
        return Object.assign({}, state, {
          isLoading: _isLoading2
        });
      }

    case constants_1.CONFIGURATION.RECEIVE:
      {
        var _response = action.response,
            _hasLoaded = action.hasLoaded,
            _isLoading3 = action.isLoading;

        var _ref = _response === null || _response === void 0 ? void 0 : _response.data,
            configuration = _ref.configuration,
            configCode = _ref.configCode;

        var _data = brightsmith_core_1.ApiNormalizer.run(_response);

        return Object.assign({}, state, {
          hasLoaded: _hasLoaded,
          isLoading: _isLoading3,
          configuration: configuration,
          configCode: configCode,
          data: _data
        });
      }

    case constants_1.CONFIGURATION.RESET:
      {
        var _response2 = action.response;
        var after = _response2.after;
        return Object.assign({}, state, {
          configuration: after
        });
      }

    case constants_1.CONFIGURATION.SET:
      {
        var _configuration = action.configuration,
            overrides = action.overrides;
        return Object.assign({}, state, {
          configuration: _configuration,
          overrides: overrides
        });
      }

    case constants_1.CONFIGURATION.SET_CONFIG_CODE:
      {
        var _configCode = action.configCode;
        return Object.assign({}, state, {
          configCode: _configCode
        });
      }

    case constants_1.CONFIGURATION.STASH:
      {
        var _configuration2 = action.configuration;
        return Object.assign({}, state, {
          stash: _configuration2
        });
      }

    case constants_1.API.RESET:
    default:
      return state;
  }
};

exports.default = apiReducer;